import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/assets";

const THEMES = [
  {
    n: "01",
    title: "Businesses",
    text: "Durable, well-run enterprises with strong management, defensible positions, and the capacity to compound over decades.",
    image: IMAGES.businesses,
  },
  {
    n: "02",
    title: "Real Assets",
    text: "Land, real estate, and productive natural assets that provide permanence, resilience, and tangible long-term value.",
    image: IMAGES.realAssets,
  },
  {
    n: "03",
    title: "Public & Private Markets",
    text: "Selective positions across public and private markets where quality, conviction, and time are decisive advantages.",
    image: IMAGES.markets,
  },
  {
    n: "04",
    title: "Select Opportunities",
    text: "Differentiated opportunities and partnerships where our capital, patience, and stewardship can create meaningful value.",
    image: IMAGES.opportunities,
  },
];

export default function InvestmentThemes() {
  return (
    <div data-testid="investment-themes-page">
      <PageHero
        testId="themes-hero"
        eyebrow="Investments"
        title={
          <>
            Where we
            <br />
            create value.
          </>
        }
        intro="We invest across public and private markets, real assets, and select opportunities — wherever quality and patience can compound."
        image={IMAGES.realAssets}
        alt="Coastal California farmland at golden hour"
      />

      <section className="bg-aveden-black py-20 lg:py-28">
        <div className="mx-auto max-w-[1500px] px-6 sm:px-10 lg:px-16">
          <div className="flex flex-col">
            {THEMES.map((theme, i) => {
              const reversed = i % 2 === 1;
              return (
                <Reveal key={theme.title}>
                  <div
                    data-testid={`theme-${i}`}
                    className={`grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20 items-center py-14 lg:py-20 ${
                      i !== 0 ? "border-t border-white/[0.05]" : ""
                    }`}
                  >
                    <div
                      className={`relative aspect-[4/3] overflow-hidden ${
                        reversed ? "lg:order-2" : ""
                      }`}
                    >
                      <img
                        src={theme.image}
                        alt={theme.title}
                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.6s] ease-out hover:scale-105"
                        loading="lazy"
                      />
                    </div>
                    <div className={reversed ? "lg:order-1" : ""}>
                      <span className="font-serif text-aveden-gold/70 text-2xl">
                        {theme.n}
                      </span>
                      <h3 className="font-serif font-light text-aveden-white text-3xl lg:text-4xl tracking-tight mt-3 mb-6">
                        {theme.title}
                      </h3>
                      <p className="font-sans font-light text-aveden-gray text-base leading-relaxed max-w-md">
                        {theme.text}
                      </p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
